<div class="home-root" [ngStyle]="homeStyles">
@if (heroVideoUrl) {
  <video
    class="videoPlayerSizing"
    width="100%"
    id="videoMain"
    autoplay
    muted
    loop
    playsinline
    preload="auto"
    [poster]="heroBannerUrl.trim() || null"
    [src]="heroVideoUrl"
    (loadedmetadata)="onHeroVideoReady($event.target)"
    (error)="onHeroVideoError()"
  ></video>
} @else if (heroBannerUrl.trim()) {
  <img class="img-fluid mb-1" [src]="heroBannerUrl" [alt]="heroHeadline">
}
<div class="flex flexColumn flexControls">
  <div class="flex justify-content-center mt-4">
    <div class="hero-headline-block">
      <h4 class="hero-title">{{ heroHeadline }}</h4>
      @if (siteDescription) {
        <p class="site-tagline">{{ siteDescription }}</p>
      }
    </div>
  </div>
  @if (categoriesWithImages.length) {
  <div class="screen-size-large">
    @let m = categoryMosaic;
    <div class="flex carousel mb-4">
      <div class="flex flex-column me-3">
        @if (m.leftLarge1) {
          <div class="overlay-box mb-3 cologe-images-large" (click)="getSearchText(m.leftLarge1)">
            <picture>
              <img class="overlay-box-img cologe-images-large" [src]="getCategoryImageUrl(m.leftLarge1)" [alt]="m.leftLarge1">
            </picture>
            <div class="overlay-box-title">
              <span>{{ m.leftLarge1 }}</span>
              <mat-icon aria-hidden="false" aria-label="Done arrow" fontIcon="arrow_downward"></mat-icon>
            </div>
          </div>
        }
        @if (m.leftPairMid.length) {
          <div class="flex mb-3">
            @for (cat of m.leftPairMid; track cat) {
              <div
                class="overlay-box cologe-images-mid"
                [class.me-3]="$first && m.leftPairMid.length > 1"
                (click)="getSearchText(cat)"
              >
                <picture>
                  <img class="overlay-box-img cologe-images-mid" [src]="getCategoryImageUrl(cat)" [alt]="cat">
                </picture>
                <div class="overlay-box-title">
                  <span>{{ cat }}</span>
                  <mat-icon aria-hidden="false" aria-label="Done arrow" fontIcon="arrow_downward"></mat-icon>
                </div>
              </div>
            }
          </div>
        }
        @if (m.leftLarge2) {
          <div class="overlay-box mb-3 cologe-images-large" (click)="getSearchText(m.leftLarge2)">
            <picture>
              <img class="overlay-box-img cologe-images-large" [src]="getCategoryImageUrl(m.leftLarge2)" [alt]="m.leftLarge2">
            </picture>
            <div class="overlay-box-title">
              <span>{{ m.leftLarge2 }}</span>
              <mat-icon aria-hidden="false" aria-label="Done arrow" fontIcon="arrow_downward"></mat-icon>
            </div>
          </div>
        }
        @if (m.leftPairSmall.length) {
          <div class="flex">
            @for (cat of m.leftPairSmall; track cat) {
              <div
                class="overlay-box cologe-images-small"
                [class.me-3]="$first && m.leftPairSmall.length > 1"
                (click)="getSearchText(cat)"
              >
                <picture>
                  <img class="overlay-box-img cologe-images-small" [src]="getCategoryImageUrl(cat)" [alt]="cat">
                </picture>
                <div class="overlay-box-title">
                  <span>{{ cat }}</span>
                  <mat-icon aria-hidden="false" aria-label="Done arrow" fontIcon="arrow_downward"></mat-icon>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="flex flex-column">
        @for (cat of m.rightMids; track cat) {
          <div class="overlay-box mb-3 cologe-images-mid" (click)="getSearchText(cat)">
            <picture>
              <img class="overlay-box-img cologe-images-mid" [src]="getCategoryImageUrl(cat)" [alt]="cat">
            </picture>
            <div class="overlay-box-title">
              <span>{{ cat }}</span>
              <mat-icon aria-hidden="false" aria-label="Done arrow" fontIcon="arrow_downward"></mat-icon>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="screen-size-smaller">
    <div class="flex carousel mb-4 category-grid category-grid--narrow">
      <div class="d-flex flex-column align-items-center me-3">
        @for (cat of categoriesWithImages; track cat) {
          <div class="overlay-box mb-2 image-width image-height" (click)="getSearchText(cat)">
            <picture>
              <img class="overlay-box-img image-width image-height" [src]="getCategoryImageUrl(cat)" [alt]="cat">
            </picture>
            <div class="overlay-box-title">
              <span>{{ cat }}</span>
              <mat-icon aria-hidden="false" aria-label="Done arrow" fontIcon="arrow_downward"></mat-icon>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  }
  <!-- <div>
    <app-picture-link-slider
      carouselID="linkSlider"
      (searchText)="getSearchText($event)"
    ></app-picture-link-slider>
  </div> -->
  <div class="flex filterArea">
    <app-activity-filter
      style="width: 70%;"
      [searchTitle]="searchText"
    ></app-activity-filter>
  </div>
</div>
</div>